module.exports = __webpack_public_path__ + "img/team.df7bb251.jpg";